import { DataConsts } from "./../../../models/DataConsts";
import { ImportGarantie } from "./../../../models/ImportGarantie";
import { ImportPortefeuilleDetail } from "../../../models/ImportPortefeuilleDetail";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-item-synthese",
  templateUrl: "./item-synthese.component.html",
  styleUrls: ["./item-synthese.component.scss"],
})
export class ItemSyntheseComponent implements OnInit {
  @Input()
  portefeuilleDetail: ImportPortefeuilleDetail;

  @Input("importGaranties")
  importGaranties: ImportGarantie[];

  importGarantieLists: ImportGarantie[];
  //encoursTotalGaranties: number;

  constructor() {}

  ngOnInit() {
    //this.encoursTotalGaranties = this.importGaranties.reduce((a, b) => a + b.montantGarantie, 0);
    this.importGarantieLists = this.importGaranties.filter(function (el) {
      return el.favorability == DataConsts.FAVORABILITY;
    });
  }
}
